var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComputer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 78,
    viewBox: "0 0 61 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON COMPUTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COMPUTER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75014 29.194C3.75014 29.194 34.8226 22.7151 43.8384 21.325C46.6812 20.9343 47.1293 25.5282 47.8544 30.1739C48.5794 34.8196 51.0046 48.6656 51.0046 48.6656L7.32504 57.1541C6.86814 51.8939 2.49593 35.1591 2.28293 33.5284C2.06993 31.8977 2.01549 29.7873 3.75026 29.1896L3.75014 29.194Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.40144 57.9377C7.40144 57.9377 4.79864 70.2605 3.81793 73.4135C2.83722 76.5664 5.56409 77.7133 16.5431 74.9456C30.5205 71.4184 56.6273 66.5659 56.6273 66.5659C56.6273 66.5659 61.3142 65.2873 58.3032 60.8607C55.2922 56.434 50.7048 49.1373 50.7048 49.1373",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.1269 72.6249C23.1269 72.6249 20.8921 67.7571 27.3957 66.4557C31.6204 65.6088 34.6253 65.1069 36.2181 64.8606C37.4694 64.6674 38.6758 64.9969 39.35 65.7341C39.9726 66.4166 40.5439 67.5329 40.6505 69.3428",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M56.9352 11.1341L50.8736 15.4295",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.1518 0.563723L39.9315 10.2093",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.2404 12.732L52.6908 1.69684",
    stroke: "#EF7056",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputer1);
export default __webpack_public_path__ + "static/media/icon-computer-1.caf843ce75896afb8cfb821dce7df681.svg";
export { ForwardRef as ReactComponent };